export const listItems = [
  {
    key: "defaultMap",
    value: "Default Map View",
  },
  {
    key: "defaultMarker",
    value: "Default Marker",
  },
  {
    key: "customMarker1",
    value: "Custom Marker 1",
  },
  {
    key: "customMarker2",
    value: "Custom Marker 2",
  },
  {
    key: "customMarker3",
    value: "Custom Marker 3",
  },
  {
    key: "dynamicMapView",
    value: "Dynamic Map View",
  },
  {
    key: "infoWindow",
    value: "Information Window",
  },
  {
    key: "zoomLevel",
    value: "Zoom Level",
  },
  {
    key: "drawingTool",
    value: "Drawing Tool",
  },
  {
    key: "geoFence",
    value: "Geofencing",
  },
  {
    key: "customMapStyles",
    value: "Custom Map Styles",
  },
];
